const user = {
  ID: /^[a-z]+[a-z0-9\-_]{5,19}$/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}/,
  NAME: /^[가-힣]{2,5}$/,
  GENDER: /MALE|FEMALE/,
  PHONE: /^\d{3}\d{3,4}\d{4}$/,
  EMAIL:
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
}

export const RegExps = { user }
